module.exports = __webpack_public_path__ + "img/product-hold.079acdab.png";